<template>
  <v-carousel
    continuous
    cycle
    interval="10000"
    class="carousel-outer"
    :show-arrows="false"
    hide-delimiter-background
    delimiter-icon="far fa-square"
  >
    <v-carousel-item src="/img/sl1a.jpg" key="0">
      <v-container>
        <v-row class="flex-column carousel-item" align="start" align-content="start" justify="end">
          <div>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="8" md="6" class="about-carousel-text">
                  <h1>Web Development</h1>
                  <div class="mt-2">
                    <p>
                      Modern
                      <strong>Responsive Web-Applications</strong> which work perfectly on any device.
                    </p>
                    <p>
                      Excellent and effective implementation of any ideas - from
                      <strong>Single-Page Web Sites</strong> to
                      <strong>Large Web-Portals</strong>.
                    </p>
                    <!-- We create moderm responsive web-applications that work great on any device. From
                    <strong>Single-Page Web Sites</strong> to
                    <strong>Large Web-Portals</strong>-->
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-row>
      </v-container>
    </v-carousel-item>
    <v-carousel-item src="/img/sl2a.jpg" key="1">
      <v-container>
        <v-row class="flex-column carousel-item" align="start" align-content="start" justify="end">
          <div>
            <v-container fluid>
              <v-row class="align-right">
                <!-- <v-spacer></v-spacer> -->
                <v-col cols="12" sm="8" md="6" class="about-carousel-text">
                  <h1>iOS and Android Mobile Development</h1>
                  <div class="mt-2">
                    <p>Always staying current with the latest technology trends.</p>
                    <p>10+ years of experience - developing iOS and Android apps since 2008</p>
                    <p>
                      Dozens of mobile apps created, including
                      <strong>Augmented Reality</strong>,
                      <strong>Location-based features</strong>, integration with
                      <strong>Wearables</strong> and other
                      <strong>Wireless Devices</strong>
                    </p>
                    <!-- We always are on top of latest mobile technologies and have been developing iOS and Android apps since the very beginning in 2008</div>
                  <div class="mt-2">
                    Our team has created dozens of mobile apps with
                    <strong>Augmented Reality</strong>,
                    <strong>Location-based features</strong>, integration with
                    <strong>Wearables</strong> and other
                    <strong>Wireless devices</strong>-->
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-row>
      </v-container>
    </v-carousel-item>
    <v-carousel-item src="/img/sl3a.jpg" key="2">
      <v-container>
        <v-row class="flex-column carousel-item" align="start" align-content="start" justify="end">
          <div>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="8" md="6" class="about-carousel-text">
                  <h1>Custom Services and Utilities Development</h1>
                  <div class="mt-2">
                    Outstanding customized solutions for businesses:
                    <ul>
                      <li>
                        <strong>Data Analysis</strong>
                      </li>
                      <li>
                        <strong>Import/Export</strong>
                      </li>
                      <li>
                        <strong>APIs and integrations</strong>, etc.
                      </li>
                    </ul>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-row>
      </v-container>
    </v-carousel-item>
    <v-carousel-item src="/img/sl4a.jpg" key="3">
      <v-container>
        <v-row class="flex-column carousel-item" align="start" align-content="start" justify="end">
          <div>
            <v-container fluid>
              <v-row class="align-right">
                <!-- <v-spacer></v-spacer> -->
                <v-col cols="12" sm="8" md="6" class="about-carousel-text">
                  <h1>Blockchain / Crypto</h1>
                  <div class="mt-2">
                    <strong>Blockchain</strong>
                    solutions to create a next level advantage. And it’s not just about Crypto!
                    <!-- Blockchain is a very interesting space and is not just Crypto. Our company has participated in implementation of several ICO's and blockchain-powered solutions -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-row>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "HomeAboutCarousel",

  data: () => ({}),
};
</script>
<style scoped lang="scss">
.carousel-outer {
  height: 400px;
  max-height: calc(100vh - 124px);
}
.carousel-item {
  height: 400px;
  max-height: calc(100vh - 124px);
  .about-carousel-text {
    padding: 15px;
    background-color: rgba($color: #001820, $alpha: 0.9);
    border-radius: 0 10px 10px 10px;

    h1 {
      line-height: 1.2;
      margin-bottom: 0.5rem;
    }
  }
  .align-right {
    justify-content: flex-end;
    .about-carousel-text {
      border-radius: 10px 0 10px 10px;
    }
  }
}
</style>